import "./footer.css"
import swiggle from "../../images/footer-swiggle.svg"
import linkedin from "../../images/linkedin_icon.svg"
import github from "../../images/github_icon.svg"
import fiverr from "../../images/fiverr_icon.svg"

export default function Hero() {
    const linkedinUrl = "https://www.linkedin.com/in/smitraj-rana-41072220a/"
    const githubUrl = "https://github.com/Smit56R"
    const fiverrUrl = "https://www.fiverr.com/smitrajrana"

    return (
        <div className="footer">
            <img className="footer-swiggle" src={swiggle} alt='swiggle' />
            <div className="footer-main">
                <div className="footer-card">
                    <img src={linkedin} alt="LinkedIn logo" />
                    <p>You can contact me on <a href={linkedinUrl} target="_blank" rel="noreferrer">LinkedIn</a></p>
                </div>
                <div className="footer-card">
                    <img src={github} alt="Github logo" />
                    <p>You can see some projects in <a href={githubUrl} target="_blank" rel="noreferrer">Github</a></p>
                </div>
                <div className="footer-card">
                    <img src={fiverr} alt="Fiverr logo" />
                    <p>I'm available for freelance projects on <a href={fiverrUrl} target="_blank" rel="noreferrer">Fiverr</a></p>
                </div>
            </div>
        </div>
    )
}